// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".automation-nav[data-v-3f7aff50]{display:grid;grid-gap:25px;align-self:start}.automation-nav .rule-or-action[data-v-3f7aff50]{display:grid;grid-template-columns:-webkit-min-content -webkit-min-content;grid-template-columns:min-content min-content;grid-gap:20px}", ""]);
// Exports
module.exports = exports;
